// extracted by mini-css-extract-plugin
export default {"sound":"KFEZW","image":"_6CUlk"};